import { throwInvalidParameter } from '@prodcard/core'

export function getEnv(varName: string): string | undefined {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const varFromWindow = ((window as any)[varName] || '').trim()
  const isVarFromWindowEmpty = varFromWindow.startsWith('${') || varFromWindow === ''
  return isVarFromWindowEmpty ? process.env[varName] : varFromWindow
}

export function getRequredEnv(varName: string): string {
  const val = getEnv(varName)
  if (!val) {
    throwInvalidParameter(`<d99af35c> ${varName} is not defined`)
  }
  return val
}
